import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`🚧 `}<strong parentName="p">{`Note:`}</strong>{` We are currently `}<strong parentName="p">{`not reviewing new connectors`}</strong>{` while we develop our new `}<a parentName="p" {...{
          "href": "https://github.com/PostHog/posthog/issues/15997"
        }}>{`batch export`}</a>{` and `}<a parentName="p" {...{
          "href": "https://github.com/PostHog/posthog/issues/16976"
        }}>{`webhook`}</a>{` functionalities. Support their development and follow along on the linked issues. `}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      